import React, { useState } from 'react';

// Components.
import AumAggregationRow from './table/AumAggregationRow';
import AddAumAggregationDialog from './modals/AddAumAggregationDialog';
import ExpandableSectionWithTable from './components/ExpandableSectionWithTable';

const AumAggregationsSection = ({
  open,
  aumAggregations,
  handleChangeAumAggregation,
  handleBlurAumAggregation,
  handleAddAumAggregation,
  handleRemoveAumAggregation,
  fetching
}) => {
  const [openAddDialog, setOpenAddDialog] = useState(false);

  const headCells = [
    { id: 'month', numeric: false, disablePadding: false, label: 'Month' },
    { id: 'year', numeric: false, disablePadding: false, label: 'Year' },
    { id: 'total_aum', numeric: false, disablePadding: false, label: 'AUM' },
    { id: 'minimum_account_size', numeric: false, disablePadding: false, label: 'Minimum Account Size' },
    { id: 'created_at', numeric: false, disablePadding: false, label: 'Import/Create Date' },
    { id: 'automatic', numeric: false, disablePadding: false, label: 'Automated/Manual' },
    { id: 'source', numeric: false, disablePadding: false, label: 'Source' },
    { id: 'options', numeric: false, disablePadding: false, label: null },
  ];

  const RowRenderer = (row, _isSelected, _index, _handleCheck) => (
    <AumAggregationRow
      key={row.id}
      pwgAumAggregation={row}
      handleBlurAumAggregation={handleBlurAumAggregation}
      handleChangeAumAggregation={handleChangeAumAggregation}
      handleRemoveAumAggregation={handleRemoveAumAggregation}
    />
  );

  const handleOpenDialog = () => setOpenAddDialog(true);

  const handleCloseDialog = () => setOpenAddDialog(false);

  return (
    <>
      <ExpandableSectionWithTable
        title='Aum Aggregations'
        open={open}
        fetching={fetching}
        headCells={headCells}
        rows={aumAggregations || []}
        RowRenderer={RowRenderer}
        onAddNew={handleOpenDialog}
        addButtonLabel='Add Aum Aggregation'
      />
      <AddAumAggregationDialog
        open={openAddDialog}
        onClose={handleCloseDialog}
        aumAggregations={aumAggregations}
        handleAddAumAggregation={handleAddAumAggregation}
      />
    </>
  );
};

export default AumAggregationsSection;
